module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av79-5c668e12d64eeac528b0e0fe67cdf4a0.jpg";